<template>
    <div>
        <div v-if="loading" class="text-center" style="padding: 40px 0;">
            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
        </div>
        <div v-else class="row">
            <div class="col-md-4" v-for="wc in worldClocks" :key="wc.city_id">
                <div class="card w-100 margin-botton-20" style="width: 18rem;">
                    <div class="card-body event-card-bg">
                        <div class="card-text text-center">
                            <p class="mb-1">{{ wc.country_name }}</p>
                            <p v-if="wc.country_iso" class="mb-1" style="font-size: 1.8rem"><span class="fi" :class="'fi-' + wc.country_iso.toLowerCase()"></span></p>
                            <h3 class="h4 fw-bold mb-1">{{ wc.city_name }}</h3>
                            <p class="h5 mb-0">
                                {{ wc.current_weekday_short_name }} {{ wc.current_time_short }}
                            </p>
                            <p class="mb-0" style="font-size: 60%">({{ wc.timezone_gmt_offset }} / {{ wc.timezone_dst_offset }})</p>
                            <p class="mb-0" style="font-size: 55%">{{ wc.timezone_formatted }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import astroTabMixin from '@/mixins/astroTab'
import locci from '@/api/locci'

const WORLD_CLOCK_CITIES = '7779,23411,13582,1686,18862,451,2787,5938,4214'

export default {
    name: 'TabWorldClock',
    mixins: [astroTabMixin],
    props: {
        active: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            worldClocks: [],
        }
    },
    watch: {
        active(val) { if (val) this.load() },
        city()      { if (this.active) this.load() },
        date()      { if (this.active) this.load() },
    },
    mounted() {
        if (this.active) this.load()
    },
    methods: {
        async load() {
            if (!this.latitude || !this.longitude || !this.timezone) return
            if (this.apiLocked) return
            this.loading = true
            await Promise.allSettled([
                locci.fetchWorldClock(WORLD_CLOCK_CITIES).then(r => { this.worldClocks = r.data.results }),
            ])
            this.loading = false
        },
    },
}
</script>

<style scoped>
.margin-botton-20 { margin-bottom: 20px; }
</style>
